//#region components/radio/radio_constants.js
var e = {
	warning: "d-radio--warning",
	critical: "d-radio--critical",
	positive: "d-radio--positive"
}, t = { RADIO_INPUT_VALIDATION_CLASSES: e };
//#endregion
export { e as RADIO_INPUT_VALIDATION_CLASSES, t as default };

//# sourceMappingURL=radio-constants.js.map